import { Button, Box, Spacer } from "@fullscript/aviary-web";
import { QRCodeCanvas } from "qrcode.react";
import { useTranslation } from "react-i18next";

import { useCopyToClipboard } from "@shared/hooks/useCopyToClipboard/useCopyToClipboard";
import { l } from "@shared/locales/i18n";

import * as styles from "./QrCode.styles";

interface Props {
  url: string;
  manualSetupCode: string;
  isLoading?: boolean;
}

const QrCode = ({ url, manualSetupCode, isLoading }: Props) => {
  const { t } = useTranslation();
  const copyToClipboard = useCopyToClipboard();

  const copyManualSetupCode = async () => {
    await copyToClipboard(manualSetupCode, { successMessage: t(l.mfa.manualSetupCodeCopied) });
  };

  return (
    <div css={styles.qrCodeWrapper}>
      <QRCodeCanvas value={url} size={180} />
      <Spacer size="small" />
      <Box isMarginless padding="xsmall">
        {manualSetupCode}
      </Box>
      <Spacer />
      <Button
        variant="secondary"
        intention="neutral"
        size="small"
        onClick={copyManualSetupCode}
        isLoading={isLoading}
      >
        {t(l.mfa.copyCode)}
      </Button>
    </div>
  );
};

export { QrCode };
